module.exports = __webpack_public_path__ + "img/homer-simpson.32904996.png";